import { useTranslation } from "react-i18next";
import { useCallback } from "react";

export function useLanguageToggle() {
  const { i18n } = useTranslation();

  const toggleLanguage = useCallback(() => {
    const next = i18n.language === "en" ? "hr" : "en";
    i18n.changeLanguage(next);
  }, [i18n]);

  const compactLabel = i18n.language === "en" ? "HR" : "EN";

  return { compactLabel, toggleLanguage };
}
